import { React, useState, useEffect, useRef } from "react";
import { PipeDesign, TableLayoutData } from "../../Pages/styledElements";
import { getShortJobCardCylinders } from "../../Services/deckleMatchServices";
import JobCardCylinder from "./JobCardCylinder";
import { TableList, RadioButtonStyle } from "../../Pages/pageStyled";
import { HaberForm } from "../../Pages/styledElements";
import Iconmoon from "../IconsFiles/icon";
import { Radio, Table, Tooltip } from "antd";
import moment from "moment";
import DuplexJobCardCylinder from "./DuplexJobCardCylinder";
import {
  currency_List,lengthUnit,weightUnit
  } from "../../Utils/Constant/MeasurementUnitList.jsx";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}

// const cylinderColumnHead = [
//   {
//     title: "1",
//     dataIndex: "1",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "2",
//     dataIndex: "2",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "3",
//     dataIndex: "3",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "4",
//     dataIndex: "4",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "5",
//     dataIndex: "5",
//     width: "0.02%",
//     align: "center",
//   },
//   {
//     title: "Total",
//     dataIndex: "total",
//     width: "0.01%",
//     align: "center",
//   },
//   {
//     title: "Trim",
//     dataIndex: "trim",
//     width: "0.01%",
//     align: "center",
//   },
//   {
//     title: "Del Date",
//     dataIndex: "deldate",
//     width: "0.1%",
//     align: "center",
//   },
//   {
//     title: "Sets",
//     dataIndex: "sets",
//     width: "0.01%",
//     align: "center",
//   },
// ];

const gridViewData = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in grid mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "grid",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in tabular mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="table" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "list",
  },
];

// const gridViewData = [
//   {
//     label: <Iconmoon icon="grid-chart" size={20} color="#EA655B" />,
//     value: "grid",
//   },
//   { label: <Iconmoon icon="table" size={20} color="#EA655B" />, value: "list" },
// ];

const DuplexJobCardCylinderContainer = ({
  // cylinderData,
  jobId,
  solution,
  multiView,
  deckle_match_page = false,
  print_function = null,
  acceptedSolution,
  jobCard,
  unitData
  // setGridView,
  // gridView,
}) => {
  const [gridView, setGridView] = useState(true);
  const [cylinderData, setCylinderData] = useState(acceptedSolution);
  const cylinderColumnHead = useRef([]);

  const solutionId =
    solution === 1 ? "solution_1" : solution === 2 ? "solution_2" : null;

    const dataSet =
    cylinderData &&
    solutionId &&
    cylinderData.partitions?.map((item, index) => {
      let totalWidth = 0;
      let totalWeight = 0;
      let leftWeight = 0;
      let rightWeight = 0;
      item.partition.forEach((current) => {
        totalWidth = totalWidth + current.breadth;
        totalWeight = totalWeight + current.weight;
        //ordersToShowInTable[+(index + 1)] = current?.breadth
        if(current.position == 'left')
        leftWeight = leftWeight + current.weight;
        else
        rightWeight = rightWeight + current.weight;

      });
      let ordersToShowInTable = {
        key: index + 1,
        total: totalWidth.toFixed(1) + ' ' + (lengthUnit[item.units.left_width].displayName).toUpperCase(),
        trim: item.total_trim_loss_width.toFixed(3)+ ' ' + (lengthUnit[item.units.total_trim_loss_width].displayName).toUpperCase(),
        deldate: moment(item.deadline).format("DD MMM YYYY"),
        weight: item.total_order_weight.toFixed(3)+ ' ' + capitalize(weightUnit[item.units.total_order_weight].displayName),
        height : item.length+ ' ' + item.units.left_width,
        leftWeight : item.left_order_weight.toFixed(3)+ ' ' + capitalize(weightUnit[item.units.left_order_weight].displayName),
        rightWeight : item.right_order_weight ? item.right_order_weight.toFixed(3)+ ' ' + capitalize(weightUnit[item.units.right_order_weight].displayName) : 0
      };
      let columnHeads = cylinderColumnHead.current;
      let leftPartitionData = "( ";
      let rightPartitionData = "( "
      item.partition.forEach((order, index) => {
       if(order.position === "left")
       leftPartitionData = leftPartitionData + order.breadth + " + ";
       else
       rightPartitionData = rightPartitionData + order.breadth + " + ";
      });

      let leftData = item.partition.filter((order) => order.position === 'left') ;
      let rightData = item.partition.filter((order) => order.position === 'right') 

      if(leftData.length && rightData.length)
      {
      leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);


      leftPartitionData = leftPartitionData + ") X " + item.left_length + " + ";

      rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);

      rightPartitionData = rightPartitionData + ") X " + item.right_length;
      }
      if(!leftData.length)
      {
        leftPartitionData = '';
        rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);

      rightPartitionData = rightPartitionData + ") X " + item.right_length;
      }

      if(!rightData.length)
      {
        rightPartitionData = '';
        leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);


        leftPartitionData = leftPartitionData + ") X " + item.left_length;
      }

      let partitionData = leftPartitionData + rightPartitionData;

      ordersToShowInTable['partitionData'] = partitionData;


      columnHeads[1] = {
        title: "Partition",
        dataIndex: "partitionData",
        width: "3%",
        align: "center",
      };

      columnHeads[2] = {
        title: "D. Com Width",
        dataIndex: "total",
        width: "1%",
        align: "center",
      };
      columnHeads[3] = {
        title: "Trim",
        dataIndex: "trim",
        width: "1%",
        align: "center",
      };
      columnHeads[4] = {
        title: "Station 1 Weight",
        dataIndex: "leftWeight",
        width: "1%",
        align: "center",
      };
      columnHeads[5] = {
        title: "Station 2 Weight",
        dataIndex: "rightWeight",
        width: "1%",
        align: "center",
      };
      columnHeads[6] = {
        title: "Total Weight",
        dataIndex: "weight",
        width: "1%",
        align: "center",
      };
      columnHeads[7] = {
        title: "Delivery",
        dataIndex: "deldate",
        width: "1%",
        align: "center",
      };

      const totalColumnCount = columnHeads.filter((item) => {
        return item.dataIndex === "total";
      });
      if (totalColumnCount.length > 1) {
        let index = -1;
        var filteredObj = columnHeads.find(function (item, i) {
          if (item.dataIndex === "total") {
            index = i;
            return i;
          }
        });
        columnHeads.splice(index, 1);
      }
      cylinderColumnHead.current = columnHeads;

      return ordersToShowInTable;
    });

  // console.log("cylinder", cylinderData);
  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "grid") {
      setGridView(true);
    } else {
      setGridView(false);
    }
    // console.log("view check", e.target.value);
  };
  useEffect(() => {
    var screen_width = window.screen.width;
    var divisor = 3.5;
    if (screen_width <= 1366) {
      if (deckle_match_page) {
        divisor = 3.8;
      } else {
        divisor = 3.2;
      }
    } else if (screen_width > 1366 && screen_width <= 1920) {
      divisor = 3.2;
    }
    var w = window.outerWidth / divisor;
    // getShortJobCardCylinders(jobId, w)
    //   .then((response) => {
    //     setCylinderData(response);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    return () => {
      setCylinderData(null);
    };
  }, [jobId]);

  return jobId ? (
    <PipeDesign>
      <div className="main-container">
        <TableList>
          <div className="radioSwitchStyle" style={{ zIndex: 10 }}>
            <div className="table-view">
              {/* add print icon to print jobcard details */}
              {!deckle_match_page && (
                <div className="List-grid-View" onClick={print_function}>
                  <div className="printIcon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                        fill="#605E5C"
                      />
                    </svg>
                  </div>
                </div>
              )}

              <HaberForm>
                <RadioButtonStyle>
                  <div
                    className="boxFormType switchRadio"
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    <Radio.Group
                      options={gridViewData}
                      onChange={handleViewChange}
                      value={gridView}
                      optionType="button"
                      buttonStyle="solid"
                      className={gridView ? "gridViewActive" : "ListViewActive"}
                    />
                  </div>
                </RadioButtonStyle>
              </HaberForm>
            </div>
          </div>
        </TableList>

        {/* {solution == 1
          ? 
          : cylinderData.solution_2.map((item) => (
              <tr>
                <JobCardCylinder cylinderData={item} />{" "}
              </tr>
            ))} */}

        {gridView ? (
          cylinderData &&
          cylinderData.partitions && 
            <div style={{ width: "100%" }}>
              <DuplexJobCardCylinder cylinderData = {cylinderData} multiview={multiView}
              jobCard = {jobCard} 
              unitData = {unitData}
              />
            </div>
        
        ) : (
          // <JobCardCylinderContainer
          //   cylinderData={cylinderData}
          //   solution={1}
          //   setGridView={setGridView}
          //   gridView={gridView}
          // />
          <div className="list-grid-view">
            <TableLayoutData>
              <div className="tableDataFormat removePagnation" >
                <Table
                size="large"
                style={{minWidth : "100% !important",width:"100% !important"}}
                  columns={cylinderColumnHead.current}
                  dataSource={dataSet}
                  onChange={onChange}
                  scroll={{
                    x:
                      800   }}
                  pagination={false}
                />
              </div>
            </TableLayoutData>
          </div>
        )}
      </div>
    </PipeDesign>
  ) : null;
};

export default DuplexJobCardCylinderContainer;
